// AGENT-A5: top-level dashboard page component.
//
// Mounts everything needed by the rebuild: design-token stylesheet, top bar,
// outer layout grid, and the four content slots — filterBar (A6),
// viewSelectors + table (A7), and charts (A8).
//
// State providers (react-query, Zustand) are intentionally mounted higher up
// — see webapp/frontend/src/App.tsx, which already wraps the whole tree in a
// QueryClientProvider. Zustand stores don't need a provider. We do NOT mount
// a second QueryClient here to keep cache keys shared with the legacy /p/...
// screens (e.g. useHealth).
//
// AGENT-A10: slots wired to the real components shipped by A6/A7/A8.

import { TopBar } from "./shell/TopBar";
import { DashboardLayout } from "./shell/DashboardLayout";
import { CategorySidebar } from "./sidebar/CategorySidebar";
// AGENT-A10: real slot components.
import { FilterBar } from "./filters/FilterBar";
// AGENT-DASH-KPI: KPI tile row mounted between ViewSelectors and MetricsTable.
import { KpiCards } from "./shell/KpiCards";
import { MetricsTable } from "./table/MetricsTable";
import { ChartsRow } from "./charts/ChartsRow";
// AGENT-A10: "View Raw Tables" modal, opened by the TopBar.
import { RawTablesModal } from "./shell/RawTablesModal";
import "./tokens.css";

export default function DashboardApp() {
  return (
    <div className="dash-app">
      <TopBar />
      <DashboardLayout
        sidebar={<CategorySidebar />}
        // AGENT-A10: A6 filter bar. The period selectors (Counts / Quantity)
        // are now rendered INSIDE FilterBar as a connected top strip, so the
        // standalone viewSelectors slot is intentionally omitted.
        filterBar={<FilterBar />}
        // AGENT-DASH-KPI: 6-tile KPI row above the table (Won Revenue,
        // Prior Revenue, # Quotes Issued, # Quotes Won, Win Rate %, Avg
        // Order $). Reads the same /api/dashboard/report payload as the
        // table — react-query dedupes so there's no extra fetch.
        kpiRow={<KpiCards />}
        // AGENT-A10: A7 metrics table.
        table={<MetricsTable />}
        // AGENT-A10: A8 combo charts row.
        charts={<ChartsRow />}
      />
      {/* AGENT-A10: View Raw Tables modal. Mounted once; renders null when
          uiStore.rawTablesOpen is false. Mounted as a sibling of
          DashboardLayout so the overlay covers the whole viewport. */}
      <RawTablesModal />
    </div>
  );
}
